import React from 'react';
import {
  Create,
  SimpleForm,
  TopToolbar,
  ListButton,
  useNotify,
  useRedirect,
} from 'react-admin';
import { CustomerForm } from './CustomerForm';

const CreateActions = () => (
  <TopToolbar>
    <ListButton />
  </TopToolbar>
);

export const CustomerCreate = () => {
  const notify = useNotify();
  const redirect = useRedirect();

  const onSuccess = (data: any) => {
    notify('Customer created successfully', { type: 'success' });
    redirect('show', 'customers', data.id);
  };

  return (
    <Create actions={<CreateActions />} mutationOptions={{ onSuccess }}>
      <SimpleForm>
        <CustomerForm isEdit={false} />
      </SimpleForm>
    </Create>
  );
};
